import * as React from 'react';
import Svg from 'react-native-svg';
function Rectangle(props) {
    return (React.createElement(Svg, { width: props.size, height: props.size, viewBox: '0 0 112 8', fill: 'none', xmlns: 'http://www.w3.org/2000/svg', ...props },
        React.createElement("mask", { id: 'mask0_3137_15660', 
            //style="mask-type:alpha"
            maskUnits: 'userSpaceOnUse', x: '0', y: '0', width: '112', height: '8' },
            React.createElement("rect", { width: '112', height: '8', rx: '4', fill: '#D9D9D9' })),
        React.createElement("g", { mask: 'url(#mask0_3137_15660)' },
            React.createElement("rect", { y: '2', width: '14', height: '4', rx: '2', fill: '#1434CB' }))));
}
export default Rectangle;
